export default class Debounce {
    static DEBOUNCE_TIMEOUT = 500; // delay in ms
    static DEBOUNCE_MIN_TIMEOUT = 100; // delay in ms
    static DEBOUNCE_NO_TIMEOUT = 0; // delay in ms
}